export default "__VITE_ASSET__C2meaWO7__"